import { defineMessages, FormattedMessage } from 'react-intl';

import { INTL_PREFIX } from '@/messages/const';

export const paymentMessages = defineMessages({
  card: {
    defaultMessage: 'Card',
    id: `${INTL_PREFIX.COMMON}.card`,
  },
  zip: {
    defaultMessage: 'ZIP',
    id: `${INTL_PREFIX.COMMON}.zip`,
  },
  viewReturnDetails: {
    defaultMessage: 'View return details',
    id: `${INTL_PREFIX.COMMON}.viewReturnDetails`,
  },
  returnDetails: {
    defaultMessage: 'Return details',
    id: `${INTL_PREFIX.COMMON}.returnDetails`,
  },
  viewOriginalOrderDetails: {
    defaultMessage: 'View original order details',
    id: `${INTL_PREFIX.COMMON}.viewOriginalOrderDetails`,
  },
  payment: {
    defaultMessage: 'Payment',
    id: `${INTL_PREFIX.COMMON}.payment`,
  },
  pay: {
    defaultMessage: 'Pay',
    id: `${INTL_PREFIX.COMMON}.pay`,
  },
  creditCard: {
    defaultMessage: 'Credit card',
    id: `${INTL_PREFIX.COMMON}.creditCard`,
  },
  payPal: {
    defaultMessage: 'PayPal',
    id: `${INTL_PREFIX.COMMON}.payPal`,
  },
  payPalExpress: {
    defaultMessage: 'PayPal Express',
    id: `${INTL_PREFIX.COMMON}.payPalExpress`,
  },
  aliPay: {
    defaultMessage: 'Ali Pay',
    id: `${INTL_PREFIX.COMMON}.aliPay`,
  },
  visa: {
    defaultMessage: 'VISA',
    id: `${INTL_PREFIX.COMMON}.visa`,
  },
  affirm: {
    defaultMessage: 'Affirm',
    id: `${INTL_PREFIX.COMMON}.affirm`,
  },
  googlePay: {
    defaultMessage: 'Google Pay',
    id: `${INTL_PREFIX.COMMON}.googlePay`,
  },
  paywithgoogle: {
    defaultMessage: 'Google Pay',
    id: `${INTL_PREFIX.COMMON}.paywithgoogle`,
  },
  applePay: {
    defaultMessage: 'Apple Pay',
    id: `${INTL_PREFIX.COMMON}.applePay`,
  },
  applePayExpress: {
    defaultMessage: 'ApplePay Express',
    id: `${INTL_PREFIX.COMMON}.applePayExpress`,
  },
  klarna_paynow: {
    defaultMessage: 'Klarna',
    id: `${INTL_PREFIX.COMMON}.klarna_paynow`,
  },
  ideal: {
    defaultMessage: 'Ideal',
    id: `${INTL_PREFIX.COMMON}.ideal`,
  },
  twint: {
    defaultMessage: 'Twint',
    id: `${INTL_PREFIX.COMMON}.twint`,
  },
  bancontact: {
    defaultMessage: 'Bancontact',
    id: `${INTL_PREFIX.COMMON}.bancontact`,
  },
  oricoFinancing: {
    defaultMessage: 'Orico Financing',
    id: `${INTL_PREFIX.COMMON}.oricoFinancing`,
  },
  paybybank: {
    defaultMessage: 'Pay by Bank',
    id: `${INTL_PREFIX.COMMON}.payByBank`,
  },
  paybybankUS: {
    defaultMessage: 'Pay by Bank',
    id: `${INTL_PREFIX.COMMON}.payByBank`,
  },
  unionPay: {
    defaultMessage: 'Union Pay',
    id: `${INTL_PREFIX.COMMON}.unionPay`,
  },
  v12: {
    defaultMessage: 'V12 Finance',
    id: `${INTL_PREFIX.COMMON}.v12`,
  },
  cembra: {
    defaultMessage: 'Cembra',
    id: `${INTL_PREFIX.COMMON}.cembra`,
  },
  creditPlus: {
    defaultMessage: 'Credit Plus',
    id: `${INTL_PREFIX.COMMON}.creditPlus`,
  },
  agos: {
    defaultMessage: 'Agos',
    id: `${INTL_PREFIX.COMMON}.Agos`,
  },
  expiryDate: {
    id: 'common.expiryDate',
    defaultMessage: 'Expiry date',
  },
  paymentMethod: {
    defaultMessage: 'Payment method',
    id: `checkout.paymentMethod.title`,
  },
  noPaymentMethods: {
    defaultMessage: 'There are no available payment methods for this {type}.',
    id: `${INTL_PREFIX.COMMON}.noPaymentMethods`,
  },
  three3DSecureInfo: {
    defaultMessage:
      'To complete your order, you may be redirected to a 3D Secure authentication page where you will be asked to confirm your identity using a means of contact that you have provided to your bank.',
    id: `checkout.paymentMethod.3dSecureDescription`,
  },
  creditCardNumber: {
    defaultMessage: 'Credit Card number*',
    id: `${INTL_PREFIX.COMMON}.creditCardNumber`,
  },
  cardNumber: {
    defaultMessage: 'Card number*',
    id: `${INTL_PREFIX.COMMON}.cardNumber`,
  },
  creditCardSecurityCode: {
    defaultMessage: 'Security code*',
    id: `${INTL_PREFIX.COMMON}.creditCardSecurityCode`,
  },
  creditCardExpiryDate: {
    defaultMessage: 'Expiry date (MM/YY)*',
    id: `${INTL_PREFIX.COMMON}.creditCardExpiryDate`,
  },
  creditCardHolderName: {
    defaultMessage: 'Full name*',
    id: `${INTL_PREFIX.COMMON}.creditCardHolderName`,
  },
  payTheBalance: {
    defaultMessage: 'Pay The Balance',
    id: `${INTL_PREFIX.COMMON}.payTheBalance`,
  },
  errorPaymentAmountAboveMaxLimit: {
    defaultMessage:
      'You can pay with {paymentType} for orders up to {maxAmount}. To combine {paymentType} with other payment methods, please select the "Split your payment" option.',
    id: 'paymentMethod.errorPaymentAmountAboveMaxLimit',
  },
  errorPaymentAdyen: {
    defaultMessage: "We're sorry, but your payment authorization was refused.",
    id: 'paymentMethod.errorPaymentAdyen',
  },
  errorPaymentAddress: {
    defaultMessage:
      'Please go back to the previous page and check your delivery, billing, and email addresses.',
    id: 'paymentMethod.errorPaymentAddress',
  },
  genericCardError: {
    defaultMessage: `Payment failed. Please check your network connection, ensure your payment method is valid, and try again. If the issue persists, contact your card issuer.`,
    id: 'paymentMethod.genericCardError',
  },
  oney: {
    defaultMessage: 'Oney',
    id: `${INTL_PREFIX.PAYMENT}.oney`,
  },
  facilypay3x: {
    defaultMessage: 'Oney 3x',
    id: `${INTL_PREFIX.PAYMENT}.facilypay3x`,
  },
  facilypay4x: {
    defaultMessage: 'Oney 4x',
    id: `${INTL_PREFIX.PAYMENT}.facilypay4x`,
  },
  payNow: {
    defaultMessage: 'Pay now',
    id: `${INTL_PREFIX.PAYMENT}.payNow`,
  },
  paymentFee: {
    defaultMessage: 'Payment fee',
    id: `${INTL_PREFIX.PAYMENT}.paymentFee`,
  },
  monthlyPayment: {
    defaultMessage: '{count} monthly payment',
    id: `${INTL_PREFIX.PAYMENT}.monthlyPayment`,
  },
  first: {
    defaultMessage: '1st',
    id: `${INTL_PREFIX.PAYMENT}.first`,
  },
  second: {
    defaultMessage: '2nd',
    id: `${INTL_PREFIX.PAYMENT}.second`,
  },
  third: {
    defaultMessage: '3rd',
    id: `${INTL_PREFIX.PAYMENT}.third`,
  },
  or: {
    defaultMessage: 'or',
    id: `${INTL_PREFIX.PAYMENT}.or`,
  },
  oneyMonths: {
    defaultMessage: '{count} months',
    id: `${INTL_PREFIX.PAYMENT}.oneyMonths`,
  },
  payWithInterestFreeCredit: {
    defaultMessage: 'PAY WITH INTEREST-FREE CREDIT',
    id: `${INTL_PREFIX.COMMON}.payWithInterestFreeCredit`,
  },
  purchaseByOpenInvoice: {
    defaultMessage: 'PURCHASE BY OPEN INVOICE',
    id: `${INTL_PREFIX.COMMON}.purchaseByOpenInvoice`,
  },
  financingZero: {
    defaultMessage: 'FINANCING 0%',
    id: `${INTL_PREFIX.COMMON}.financingZero`,
  },
  instantBankPayment: {
    defaultMessage: 'Instant bank payment',
    id: `${INTL_PREFIX.PAYMENT}.instantBankPayment`,
  },
  secureBankAccountPayment: {
    defaultMessage:
      'Pay directly from any of your bank accounts, backed by bank-level security',
    id: `${INTL_PREFIX.PAYMENT}.secureBankAccountPayment`,
  },
  noCardsNoAppNoRegistration: {
    defaultMessage: 'No cards, no app download, no registration',
    id: `${INTL_PREFIX.PAYMENT}.noCardsNoAppNoRegistration`,
  },
  paymentSplitPartAdded: {
    defaultMessage: 'You have added the {ordinal} part of payment',
    id: `${INTL_PREFIX.PAYMENT}.split.partAdded`,
  },
  maxSingleUseSplitPaymentLimit: {
    defaultMessage:
      'You can use {paymentName} only once for a total amount of up to {limitMax}.',
    id: `${INTL_PREFIX.PAYMENT}.maxSingleUseSplitPaymentLimit`,
  },
  splitPaymentMinLimit: {
    defaultMessage:
      "Payment amount cannot be less than the {paymentName}'s minimum ({limitMin}) limit.",
    id: `${INTL_PREFIX.PAYMENT}.splitPaymentMinLimit`,
  },
  splitPaymentMaxLimit: {
    defaultMessage:
      "Payment amount cannot be higher than the {paymentName}'s maximum ({limitMax}) limit.",
    id: `${INTL_PREFIX.PAYMENT}.splitPaymentMaxLimit`,
  },
  splitPaymentMaxLimitCembra: {
    defaultMessage:
      'You can use Financing 0% only once for a total amount of up to {limitMax}.',
    id: `${INTL_PREFIX.PAYMENT}.splitPaymentMaxLimitCembra`,
  },
  bankTransfer: {
    defaultMessage: 'Bank transfer',
    id: `${INTL_PREFIX.PAYMENT}.bankTransfer`,
  },
  firstPaymentCompleted: {
    defaultMessage: 'First payment successfully completed',
    id: `${INTL_PREFIX.PAYMENT}.split.firstPaymentCompleted`,
  },
  secondPaymentCompleted: {
    defaultMessage: 'Second payment successfully completed',
    id: `${INTL_PREFIX.PAYMENT}.split.secondPaymentCompleted`,
  },
  thirdPaymentCompleted: {
    defaultMessage: 'Third payment successfully completed',
    id: `${INTL_PREFIX.PAYMENT}.split.thirdPaymentCompleted`,
  },
  fourthPaymentCompleted: {
    defaultMessage: 'Fourth payment successfully completed',
    id: `${INTL_PREFIX.PAYMENT}.split.fourthPaymentCompleted`,
  },
});

export const PayOptional = (separator: string, ...args: number[]) => {
  let installmentsText = '';
  args.forEach((count, index) => {
    if (index === 0) {
      installmentsText = installmentsText + count;
      return;
    }
    installmentsText = installmentsText + ` ${separator} ` + count;
  });
  return (
    <FormattedMessage
      defaultMessage='Pay with your credit card in {installments} months.'
      id={INTL_PREFIX.PAYMENT + '.oneyTip'}
      values={{
        installments: installmentsText,
      }}
    />
  );
};
export const PaidWith = (amount: string, paymentMethod?: string) => {
  return (
    <FormattedMessage
      defaultMessage='{amount} with {paymentMethod}'
      id={`${INTL_PREFIX.PAYMENT}.split.paidWith`}
      values={{
        amount: <span style={{ fontWeight: 700 }}>{amount}</span>,
        paymentMethod: paymentMethod,
      }}
    />
  );
};

export const getPaymentCompletedMsg = (ordinal: number) => {
  switch (ordinal) {
    case 2:
      return paymentMessages.secondPaymentCompleted;
    case 3:
      return paymentMessages.thirdPaymentCompleted;
    case 4:
      return paymentMessages.fourthPaymentCompleted;
    default:
      return paymentMessages.firstPaymentCompleted;
  }
};
